// Campus photo for /colleges/howard-university: CC BY-SA 4.0, by Derek E. Morton, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHoward_University_Washington_DC_-_Founders_Library.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/howard-university/; credited under the photo.
const photo = {
    "slug": "howard-university",
    "alt": "Founders Library and its white clock tower across the main quadrangle at Howard University in Washington, DC",
    "src": "/colleges/howard-university/campus-1600.webp",
    "srcSmall": "/colleges/howard-university/campus-800.webp",
    "srcMid": "/colleges/howard-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/howard-university/og.jpg",
    "title": "Howard University Washington DC - Founders Library",
    "author": "Derek E. Morton",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHoward_University_Washington_DC_-_Founders_Library.jpg",
    "read": "2026-10-02"
};

export default photo;
